module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_yoso_location-64d3c77aa952c8a21dea8b57d64c1383.webp";